import {Languages} from './languages';
import {FileLoader} from './file-loader';

export const fileLoaderFactory = (languages: Array<Languages>): FileLoader => new FileLoader(languages);
